<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="85.95"
    height="86.055"
    xmlns:v="https://vecta.io/nano"
  >
    <defs>
      <clipPath id="A">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-297.54 -437.466)" />
      </clipPath>
    </defs>
    <g fill="none" stroke="#41693d" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4">
      <path
        d="M49.76 68.152l4.233 15.797M36.242 17.705L32.034 2m29.421 59.454l11.531 11.529M12.993 12.994l11.503 11.501M83.95 53.991l-15.724-4.213M17.779 36.263L2 32.035M17.83 49.78L2.001 54.023m81.948-21.962l-15.673 4.2"
      />
      <path
        d="M72.983 13.07L61.559 24.494M24.601 61.455L12.995 73.063m36.817-55.358l4.18-15.599M32.036 84.055l4.261-15.903"
      />
    </g>
    <path
      d="M0 0a16 16 0 0 1-15.997-15.997A16 16 0 0 1 0-31.994a16 16 0 0 1 15.997 15.997A16 16 0 0 1 0 0m0-3c7.167 0 12.997-5.83 12.997-12.997S7.167-28.994 0-28.994s-12.997 5.831-12.997 12.997S-7.167-3 0-3"
      transform="matrix(1.333333 0 0 -1.333333 43.0276 21.5926)"
      clip-path="url(#A)"
      fill="#41693d"
    />
  </svg>
</template>
